import dynamic from 'next/dynamic';
import NextLink from 'next/link';

import Button from 'shopper/components/Button';
import Heading from 'shopper/components/Heading';

import Image from 'components/Image';

import { sendEvent } from 'lib/gtag';
import placeholder from 'lib/placeholder';

import APP from 'constants/app';
import BLACK_FRIDAY from 'constants/blackFriday';
import LINKS from 'constants/links';

const FloatProgressGameBarButton = dynamic(
  () => import('./FloatProgressGameBarButton'),
  { ssr: false }
);

const Hero = ({ onClick }) => {
  return (
    <>
      <section className="mt-4 flex flex-col items-center justify-center gap-8 lg:mt-0 lg:flex-row lg:items-center lg:gap-10">
        <Image
          alt="Black Friday no Promobit"
          className="h-[160px] w-[295px] lg:h-[305px] lg:w-[556px]"
          height={305}
          src={`${APP.LOCAL_IMAGE_PATH}/features/my-black-friday/girl-running-to-bf.svg`}
          width={400}
          priority
        />
        <div className="flex flex-col gap-4 md:gap-6">
          <Heading className="text-center lg:text-start">
            {placeholder('titles.joinTheGame')}
          </Heading>
          <Heading
            as="h2"
            className="text-center font-regular lg:text-start"
            size="size4"
          >
            {placeholder('subtitles.bfMissionsGame')}
          </Heading>
          <div className="flex flex-col gap-4 md:gap-6 lg:flex-row">
            <NextLink href={LINKS.SAVING_GAME} prefetch={false} passHref>
              <Button
                as="a"
                className="w-full lg:w-fit"
                size="size3"
                type="neutral"
                onClick={() => {
                  sendEvent({
                    action: 'missions_start',
                    category: BLACK_FRIDAY.MY_BF_PAGE.GA_EVENT_CATEGORY,
                  });
                }}
              >
                {placeholder('actions.playTheGame')}
              </Button>
            </NextLink>
            <Button
              as="a"
              className="w-full cursor-pointer lg:w-fit"
              size="size3"
              type="neutral-stroke"
              onClick={onClick}
            >
              {placeholder('actions.knowMore')}
            </Button>
          </div>
          <FloatProgressGameBarButton myBlackFridayPage />
        </div>
      </section>
    </>
  );
};

export default Hero;
